import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {Store} from '@ngrx/store';
import {Hold} from '@store/holds/holds.types';
import {HoldsActions} from '@store/holds/holds.actions';
import {HoldsSelectors} from '@store/holds/holds.selectors';
import {HoldStatusColumnComponent} from '@app/my-account/holds/table-column-components/hold-status-column.component';
import {ActionButtonsComponent} from '@aviary/components/action-buttons/action-buttons.component';
import {IconButtonComponent} from '@aviary/buttons/icon-button/icon-button.component';

@Component({
  selector: 'px-combined-hold-status-actions-column',
  host: {
    class: 'text-wrap',
  },
  template: `
    <div class="flex flex-col">
      @if (showActions) {
        <!-- Action Icon Button(s) -->
        <mx-action-buttons>
          <mx-icon-button icon="edit" tooltip="Edit Hold" [enabled]="editEnabled" (click)="editHoldClicked()"/>
        </mx-action-buttons>
      }
      
      <!-- Status -->
      <px-hold-status-column [hold]="hold"/>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HoldStatusColumnComponent, ActionButtonsComponent, IconButtonComponent]
})
export class CombinedHoldStatusActionsColumnComponent {
  @Input({required: true}) public hold: Hold;
  @Input() public editEnabled: boolean;
  @Input() public showActions: boolean;
  private readonly store = inject(Store);
  public readonly selectors = HoldsSelectors.OnHold;

  public editHoldClicked(): void {
    this.store.dispatch(HoldsActions.showEditHold(this.hold));
  }
}
